<section
  class="collapsed-supplier"
  [style.--supplier-accent]="data.accentColor">
  <header class="collapsed-supplier-header">
    <strong class="collapsed-supplier-name">{{ data.name }}</strong>
    @if (data.email) {
      <span class="collapsed-supplier-email">{{ data.email }}</span>
    }
  </header>

  @if (data.responded) {
    <div class="collapsed-supplier-meta">
      <span>Respondido em {{ data.respondedAt | date: 'dd/MM/yyyy' }}</span>
      @if (data.validityLabel) {
        <span
          class="collapsed-supplier-validity"
          [class.collapsed-supplier-validity--expired]="data.validityStatus === 'expired'"
          [class.collapsed-supplier-validity--expiring]="data.validityStatus === 'expiring'"
          >{{ data.validityLabel }}</span
        >
      }
    </div>

    <ul class="collapsed-supplier-items">
      @for (item of data.items; track item.code) {
        <li
          class="collapsed-supplier-item"
          [class.collapsed-supplier-item--selected]="item.selected">
          <span
            class="collapsed-supplier-item-name"
            [title]="'#' + item.code + ' ' + item.product">
            #{{ item.code }} {{ item.product }}
          </span>
          <span class="collapsed-supplier-item-price">
            @if (item.price != null) {
              {{ item.price | currency: 'BRL' : 'symbol' : '1.2-2' }}
              @if (item.bestPrice) {
                <mat-icon
                  class="collapsed-supplier-best"
                  svgIcon="earnings"
                  aria-label="Melhor preço" />
              }
            } @else {
              <em>Não cotado</em>
            }
          </span>
        </li>
      }
    </ul>

    <div class="collapsed-supplier-conditions">
      <div class="collapsed-supplier-row">
        <span>Pagamento</span>
        <strong>{{ data.paymentMethod || 'N/A' }} · {{ data.paymentTerms || 'N/A' }}</strong>
      </div>
      <div class="collapsed-supplier-row">
        <span>Frete</span>
        <strong>{{
          data.freight != null ? (data.freight | currency: 'BRL' : 'symbol' : '1.2-2') : 'N/A'
        }}</strong>
      </div>
    </div>

    <div class="collapsed-supplier-total">
      <span>Total da proposta original</span>
      <strong>{{
        data.quotedTotal != null ? (data.quotedTotal | currency: 'BRL' : 'symbol' : '1.2-2') : '--'
      }}</strong>
    </div>
    <div class="collapsed-supplier-counts">
      {{ data.quotedCount }} de {{ data.items.length }} itens cotados · {{ data.bestPriceCount }} no melhor preço
      @if (data.selectedCount > 0) {
        · {{ data.selectedCount }} selecionado(s)
      }
    </div>
  } @else {
    <div class="collapsed-supplier-row collapsed-supplier-pending">
      <span>Status</span>
      <strong>Aguardando resposta</strong>
    </div>
  }

  <p class="collapsed-supplier-hint">Clique no olho para mostrar a coluna de novo.</p>
</section>
